export default "__VITE_ASSET__C9T8_X3w__"